import { Box, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import List, { HeadCell } from 'components/list/list';

import React from 'react';
import ProductsUnavailableAlert from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/recommendations/products-unavailable-alert';
import StandardRecommendationRow from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/recommendations/standard/standard-recommendation-row';
import { useFilteredRecommendations } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/hooks/use-filtered-recommendations';

type Props = { filters: string[] };

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.orders';

const StandardRecommendationsList: FC<Props> = ({ filters }) => {
  const intl = useIntl();
  const theme = useTheme();
  const { filteredRecommendations, isLoading } = useFilteredRecommendations(filters);

  const columns: HeadCell[] = [
    {
      id: 'orderStatus',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.orderStatus` }),
    },
    {
      id: 'autoConfirm',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.autoConfirm` }),
    },
    {
      id: 'dispatchDate',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.dispatchDate` }),
    },
    {
      id: 'deliveryDate',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.deliveryDate` }),
    },
    {
      id: 'quantity',
      align: 'center',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.quantity` }),
    },
    {
      id: 'actions',
      label: '',
      align: 'right',
    },
  ];

  return (
    <Box display={'flex'} flexDirection={'column'} gap={2}>
      <Box display={'flex'} justifyContent={'flex-start'} gap={2} alignItems={'center'}>
        <Typography>
          <FormattedMessage id={`${PAGE_NAME_ID}.list.forecasts`} />
        </Typography>
        <Box borderBottom={`1px solid ${theme.palette.darkBlue.o25}`} width={'100%'} />
      </Box>
      <ProductsUnavailableAlert />
      <List
        options={columns}
        isLoading={isLoading}
        noResult={{
          show: !filteredRecommendations.length,
          text: intl.formatMessage({ id: `general.noResults` }),
        }}>
        {filteredRecommendations.map((recommendation, idx) => (
          <StandardRecommendationRow key={idx} recommendation={recommendation} />
        ))}
      </List>
    </Box>
  );
};

export default React.memo(StandardRecommendationsList);
